import React from "react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"
// import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"

function FadeInWhenVisible({ children }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      {children}
    </motion.div>
  )
}

const Testimonial = ({ content }) => {
  const { frontmatter, body } = content[0].node
  // const image = getImage(frontmatter.image)
  return (
    <MDXProvider
      components={{
        p: props => (
          <p
            {...props}
            className="text-2xl md:text-3xl lg:text-4xl font-bold leading-relaxed tracking-tight text-center text-primary-text"
          />
        ),
        em: props => (
          <em
            {...props}
            className="text:lg md:text-2xl font-normal leading-relaxed tracking-tight text-gray-500"
          />
        ),
      }}
    >
      <section
        id="testimonials"
        className="bg-tertiary my-14 md:my-24 xl:my-44 py-48 md:py-52"
      >
        <div className="w-11/12 lg:w-1/2 xl:w-7/12 mx-auto">
          <p className="font-body2 text-3xl md:text-4xl lg:text-5xl font-bold mb-12 uppercase text-center tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-blue-500 to-gray-900 dark:from-gray-700 dark:via-gray-300 dark:to-white">
            Testimonials
          </p>
          <p className="text-md md:text-2xl mb-24 italic text-secondary-text text-center tracking-wide">
            See what some people have had to say about Danniel Hansel.
          </p>
          <FadeInWhenVisible>
            <div className="flex flex-col space-y-6 items-center justify-center px-6">
              <div className="flex-shrink-0 mx-auto relative overflow-hidden rounded-full w-36 h-36 shadow-xl shadow-tertiary">
                  <img src={frontmatter.thumbnailUrl} className="object-cover h-full w-full rounded-full" alt={frontmatter.author} />
                {/* <GatsbyImage image={image} alt={frontmatter.title} /> */}
              </div>
              <MDXRenderer>{body}</MDXRenderer>
              <p className="text-xl md:text-2xl lg:text-3xl text-center italic">
                {frontmatter.author}, {frontmatter.company}
              </p>
            </div>
          </FadeInWhenVisible>
        </div>
      </section>
    </MDXProvider>
  )
}

export default Testimonial
